<template>
    <!-- 模型管理 -->
    <div class="max_box">
        <!-- top -->
        <div class="top_box"><span class="top_span">模型管理</span></div>
        <!-- form -->
        <div class="form_box">
            <label class="form_label"></label>
            <el-select v-model="form_select.group" placeholder="请选择模型分组" class="form_input" size="small" clearable>
                <el-option
                        v-for="item in modelGroup"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                </el-option>
            </el-select>
            <el-select v-model="form_select.skillId" placeholder="请选择技能组" class="form_input" size="small" clearable>
                <el-option
                        v-for="item in skillGroup"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                </el-option>
            </el-select>
            <el-input
              size="small"
              class="selectInput"
              style="width:180px"
              v-model="form_select.name"
              placeholder="请输入名称"
              @keyup.enter.native="clickSearch()"
            >
              <svg slot="suffix" class="icon" @click="clickSearch" aria-hidden="true">
                <use xlink:href="#iconsearchicon" />
              </svg>
            </el-input>
          <!--  <el-input size="small"
                      placeholder="请输入名称"
                      v-model="form_select.name"
                      class="input-with-select form_input"
                      style="width: 180px;"
                      @keyup.enter.native="clickSearch()">
                <el-button @click="clickSearch()" size="small"  slot="append" :icon="load_table ? 'el-icon-loading' : 'el-icon-search'"></el-button>
            </el-input>-->
            <!--<el-button type="primary" size="small" icon="el-icon-upload2" style="margin-right: 10px;margin-left: 0px" plain>导入</el-button>
            <el-button type="primary" size="small" icon="el-icon-download" style="margin-right: 10px;margin-left: 0px" plain>导出</el-button>-->
            <el-button type="primary" size="small" style="margin-right: 10px;margin-left: 0px;" @click="opendialog">编辑模型组</el-button>
        </div>
        <!-- table -->
        <el-table class="table_box_el_table" tooltip-effect="light" placement="top" :data="tableData"  @filter-change="filterChange" v-loading="load_table" ref="el_table" size="size">
            <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="50px"></el-table-column>
            <!--<el-table-column
                    label="质检类型"
                    align="center"
                    :filters="tableModelType"
                    :filter-multiple="false"
                    :column-key="'type'"
                    width="120px"
            >-->
            <el-table-column label="质检类型" align="center" :show-overflow-tooltip="true" width="120px">
                <template slot-scope="scope">
                    <span  style="margin-left: -8px;">{{ tableModelType[Number(scope.row.model_type)].text }}</span>
                </template>
            </el-table-column>
            <el-table-column label="所属分组" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span class="table_span" style="margin-left: -8px;">{{ getGroupName(scope.row.group) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="模型名称" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="light" :disabled="scope.row.remark == ''" :content="'备注：' + scope.row.remark" placement="bottom-start" transition="el-collapse-transi">
                        <span :class="scope.row.remark == '' ? 'table_span' : 'table_span_ok'" style="margin-left: -5px;">{{ scope.row.name }}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column
                    label="模型类型"
                    align="center"
                    min-width="120px"
                    :filters="tableModelTypeTemplate"
                    :filter-multiple="false"
                    :column-key="'typeTemplate'"
                    :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span class="table_span" style="margin-left: -8px;">{{ tableModelTypes[Number(scope.row.type)] }}</span>
                </template>
            </el-table-column>
            <el-table-column label="技能组" align="center" :show-overflow-tooltip="true" max-width="200px">
                <template slot-scope="scope">
                    <span class="table_span">{{ getSkillName(scope.row.skillGroup) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="模型位置"
                             align="center"
                             :show-overflow-tooltip="true"
                             min-width="120px"
                             :filters="tableModelAttrPos"
                             :filter-multiple="false"
                             :column-key="'attrPoss'">
                <template slot-scope="scope">
                    <span class="table_span">{{scope.row.type === 1 ? '--' : (scope.row.attrPos === 1 ? ('会话初' + scope.row.attrPosValue + '句内') : '任意')}}</span>
                </template>
            </el-table-column>
            <el-table-column label="角色" align="center" :show-overflow-tooltip="true" v-if="tableShow.roles">
                <template slot-scope="scope">
                    <span class="table_span">{{ scope.row.type === 0 || scope.row.attrActionId !== 'silence' ? '--' : tableModelRole[Number(scope.row.role)] }}</span>
                </template>
            </el-table-column>
            <el-table-column label="修改日期" align="center" :show-overflow-tooltip="true" v-if="tableShow.updateTime">
                <template slot-scope="scope">
                    <span class="table_span">{{dateToStrings(new Date(scope.row.updateDate), 'YYYY-MM-dd hh:mm:ss')}}</span>
                </template>
            </el-table-column>
            <el-table-column label="修改人" align="center" :show-overflow-tooltip="true" width="120px" v-if="tableShow.updateUser">
                <template slot-scope="scope">
                    <span class="table_span">{{ scope.row.updateUser }}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" align="center" :show-overflow-tooltip="true" v-if="tableShow.createdTime">
                <template slot-scope="scope">
                    <span class="table_span">{{dateToStrings(new Date(scope.row.createdTime), 'YYYY-MM-dd hh:mm:ss')}}</span>
                </template>
            </el-table-column>
            <el-table-column label="创建人" align="center" :show-overflow-tooltip="true" v-if="tableShow.createdUser">
                <template slot-scope="scope">
                    <span class="table_span">{{ scope.row.createUser }}</span>
                </template>
            </el-table-column>
            <el-table-column
                    label="状态"
                    align="center"
                    :show-overflow-tooltip="true"
                    :filters="tableModelStatus"
                    :filter-multiple="false"
                    :column-key="'status'"
                    :filtered-value="form_select.status == '' ? [] : [form_select.toString()]"
                    width="120px"
            >
                <template slot-scope="scope">
                    <el-switch
                            @change="status(scope.row)"
                            v-model="scope.row.status"
                            :active-value="1"
                            :inactive-value="0"
                            active-color="#337eff"
                            :disabled="status_id==scope.row.id || !$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101410')"
                            inactive-color="#e1e3e6"  style="margin-left: -10px;">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column
                    label="操作"
                    align="center"
                    fixed="right"
                    :filters="[{ text: '角色', value: '3' }, { text: '修改日期', value: '5' }, { text: '修改人', value: '2' }, { text: '创建时间', value: '4' }, { text: '创建人', value: '1' }]"
                    :filter-multiple="true"
                    :column-key="'columns'"
                    width="120px">
                <template slot-scope="scope">
                    <div class="table_button_box">
                        <el-tooltip class="item" effect="light" :content="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430') ? '编辑' : '查看'" placement="top">
                           <!-- <el-button :icon="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430') ? 'el-icon-edit' : 'el-icon-view'"
                                       class="table_button" circle size="mini" @click="edit(scope.row)" type="primary">
                            </el-button>-->
                           <!--<i class="iconfont icontable-bianji" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430')" @click="edit(scope.row)" type="primary" style="margin: 0 8px"></i>-->
                          <el-button type="text" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101430')" @click="edit(scope.row)">
                            <svg class="icon icon-bianji" aria-hidden="true">
                              <use xlink:href="#icontable-bianji" />
                            </svg>
                          </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="light" content="删除" placement="top" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101420')">
                           <!-- <el-button :icon="remove_id==scope.row.id?'el-icon-loading':'el-icon-delete'"
                                       class="table_button" circle size="mini" @click="reomve(scope.row.id)" type="danger">
                            </el-button>-->
                            <!--<i class="iconfont icontable-delete" @click="reomve(scope.row.id)" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101420')" style="margin: 0 8px"></i>-->
                          <el-button type="text" @click="reomve(scope.row.id)" v-if="$qcAuthUtis.qcHasButtonAuth('aicc-qc', '101420')">
                            <svg class="icon icon-delete" aria-hidden="true">
                              <use xlink:href="#icontable-delete" />
                            </svg>
                          </el-button>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- page -->
        <Page v-bind:init_item="pageBuild" @currentPage="currentPage"/>
        <!-- dialog -->
        <el-dialog
                title="编辑模型组"
                :visible.sync ="dialog.show"
                width="540px"
                @closed="dialogClosed"
        >
            <div class="dialog_top">
                <el-input
                  class="selectInput"
                  style="width:280px"
                  size="medium"
                  v-model="modelGroupSelectName"
                  placeholder="请输入名称"
                  @keyup.enter.native="searchModelGroupList(false)"
                >
                  <svg slot="suffix" class="icon" @click="searchModelGroupList(false)" aria-hidden="true">
                    <use xlink:href="#iconsearchicon" />
                  </svg>
                </el-input>
             <!--   <el-input class="form_input"
                          style="width: 280px"
                          v-model="modelGroupSelectName"
                          placeholder="请输入名称"
                          size="small"
                          suffix-icon="el-icon-search"
                          @keyup.enter.native="searchModelGroupList(false)"
                          clearable>
                </el-input>
                <el-button size="small" icon="el-icon-search" class="right dialog_top_but" @click="searchModelGroupList(false)" style="margin-left: 10px;width: 80px">查询</el-button>
                -->
              <el-button type="info" size="small" icon="el-icon-plus" class="right dialog_top_but" @click="addGroupBut()">新增</el-button>
            </div>
            <el-collapse-transition>
                <div class="dialog_body_in" v-show="dialog_form_input.type == 1 || dialog_form_input.type == 0">
                    <div class="dialog_body_top">
                      {{dialog_form_input.type_dic[dialog_form_input.type]}}
                      <div class="dialog_body_top_close" @click="closeGroupBut()" v-show="dialog_form_input.type == 1 || dialog_form_input.type == 0">
                        <i class="el-icon-close"></i>
                      </div>
                    </div>
                  <div class="dialog_content">
                    <el-input class="dialog_form_input"
                              v-model="dialog_form_input.name"
                              placeholder="请输入名称"
                              size="small"
                              maxlength="32"
                              show-word-limit
                    >
                    </el-input>
                    <el-button size="small" class="right" v-show="dialog_form_input.type == 1" @click="clickDialogUpdate()">保 存</el-button>
                    <el-button size="small" class="right" v-show="dialog_form_input.type == 0" @click="clickDialogSave()">保 存</el-button>
                  </div>
                </div>
            </el-collapse-transition>
            <div class="dialog_foot" v-show="modelGroupAll.length > 0">
                    <el-tooltip class="item" effect="light" :content="item.name" placement="top" v-for="(item,index) in modelGroupAll" :key="index" >
                        <div style="display: inline-block;position: relative">
                            <div class="dialog_foot_div" :class="dialogFootDivClass(item.id)" @click.stop="editGroupBut(item)">
                                <span style="font-size: 12px;color: #666;line-height: 14px">{{item.name}}</span>
                            </div>
                            <div class="dialog_foot_div_close" @click="clickDialogDelete(item)"><i class="el-icon-close dialog_foot_div_close_text"></i></div>
                        </div>
                    </el-tooltip>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Page from '@/views/qc/public/PageComponent'
import { modelManagerList, modelGroupList, savemodelGroup, updatemodelgroup, removemodelgroup, removemodel, updateModelFlagPublish, QCBASE } from '@/api/qc/model'
import { dateToString } from '@/views/qc//utils/dateUtils'
export default {
  name: 'modelManagement',
  components: {
    Page
  },
  data: function () {
    return {
      dialog_form_input: {
        id: '',
        name: '',
        type: 2,
        type_dic: ['新增模型组', '修改模型组']
      },
      form_select: {
        // 模型分组
        group: '',
        // 状态
        status: [],
        // 名称
        name: '',
        // 质检类型
        modelType: '',
        // 技能组ID
        skillId: '',
        type: '',
        attrPos: ''
      },
      // 技能组
      skillGroup: [],
      tableShow: {
        createdUser: false,
        updateUser: false,
        createdTime: false,
        roles: false,
        updateTime: false
      },
      tableData: [],
      remove_id: '',
      status_id: '',
      load_table: false,
      pageBuild: {
        page_size: 10,
        total: 0,
        currentPage: 1,
        marginBottom: '50px'
      },
      modelGroup: [],
      modelGroupSelectName: '',
      modelGroupAll: [],
      dialog: {
        show: false
      },
      deleteGroupId: '',
      tableModelType: [{ text: '事后质检', value: 0 }, { text: '实时质检', value: 1 }],
      tableModelTypeTemplate: [{ text: '语义模型', value: 0 }, { text: '行为模型', value: 1 }],
      tableModelAttrPos: [{ text: '会话初', value: 1 }, { text: '任意', value: 0 }],
      tableModelRole: ['客户或者坐席', '客户', '坐席'],
      tableModelStatus: [{ text: '未发布', value: '0' }, { text: '已发布', value: '1' }],
      tableModelTypes: ['语义模型', '行为模型', '高级模型']
    }
  },
  methods: {
    /** 输出技能组名称 */
    getSkillName(list) {
      const that = this
      let str = ''
      let isFirst = true
      list.forEach(function (item, index) {
        if (item) {
          let name
          that.skillGroup.forEach(function (it, indexIn) {
            if (it.value === item) {
              name = it.text
            }
          })
          if (name !== undefined) {
            if (!isFirst) {
              str += ' , '
            } else {
              isFirst = false
            }
            str += name
          }
        }
      })
      return str
    },
    /**
     * 查询技能组
     */
    querySkillGroup () {
      const that = this
      // 取客服组
      // getCustomerGroup().then(response => {
      this.$qcAuthUtis.qcSkillGroupList('aicc-qc', '101100', function(response) {
        that.skillGroup = []
        response = response.data.data
        for (var i = 0; i < response.length; i++) {
          var json = {
            text: response[i].name,
            value: response[i].id
          }
          that.skillGroup.push(json)
        }
        // 回调参数
        that.routerSelect()
      })
    },
    /**
     * 日期转字符串
     */
    dateToStrings(dat, formet) {
      return dateToString(dat, formet)
    },
    /**
     * 删除模型
     */
    deleteModel() {
      const params = {
        id: this.remove_id
      }
      removemodel(params).then(response => {
        response = response.data.data
        // eslint-disable-next-line eqeqeq
        if (response.status == 'success') {
          this.search()
        }
        this.remove_id = ''
        window.qcMessage({ type: 'success', text: '删除成功' })
      }).catch(response => {
        this.remove_id = ''
        window.qcMessage({ type: 'warning', text: '删除失败' })
      })
    },
    /**
     * 输出模型分组名称
     */
    getGroupName(id) {
      for (let i = 0; i < this.modelGroupAll.length; i++) {
        // eslint-disable-next-line eqeqeq
        if (id == this.modelGroupAll[i].id) {
          return this.modelGroupAll[i].name
        }
      }
      return ''
    },
    /**
     * 模型分组-删除确认回调
     */
    reomveGroup() {
      const params = {
        id: this.deleteGroupId
      }
      removemodelgroup(params).then(response => {
        response = response.data.data
        // eslint-disable-next-line eqeqeq
        if (response.status == 'success') {
          this.searchModelGroupList(true)
          this.closeGroupBut()
        } else {
          window.qcMessage({ type: 'warning', text: response.msg })
        }
      }).catch(response => {
      })
    },
    /**
     * 模型分组点击删除
     */
    clickDialogDelete(item) {
      this.deleteGroupId = item.id
      window.qcMessageBox({ title: '', text: '你确定要删除该分组吗？', f: this.reomveGroup, c: null })
    },
    /**
     * 模型分组点击修改
     */
    clickDialogUpdate() {
      // eslint-disable-next-line eqeqeq
      if (this.dialog_form_input.name == '') {
        window.qcMessage({ type: 'warning', text: '分组名称不能为空' })
      } else {
        const params = {
          id: this.dialog_form_input.id,
          name: this.dialog_form_input.name
        }
        updatemodelgroup(params).then(response => {
          response = response.data.data
          // eslint-disable-next-line eqeqeq
          if (response.status == 'success') {
            this.searchModelGroupList(true)
            this.closeGroupBut()
          }
        }).catch(response => {
        })
      }
    },
    /**
     * 模型分组-点击保存
     */
    clickDialogSave() {
      // eslint-disable-next-line eqeqeq
      if (this.dialog_form_input.name == '') {
        window.qcMessage({ type: 'warning', text: '分组名称不能为空' })
      } else {
        const params = {
          name: this.dialog_form_input.name
        }
        savemodelGroup(params).then(response => {
          response = response.data.data
          // eslint-disable-next-line eqeqeq
          if (response.status == 'success') {
            this.searchModelGroupList(true)
            this.addGroupBut()
          }
        }).catch(response => {
        })
      }
    },
    /**
     * 关闭模型分组回调
     */
    dialogClosed() {
      this.closeGroupBut()
      this.modelGroupSelectName = ''
    },
    /**
     * 模型分组-选中高亮
     */
    dialogFootDivClass(id) {
      // eslint-disable-next-line eqeqeq
      if (id == this.dialog_form_input.id) {
        return 'dialog_foot_div_activity'
      } else {
        return ''
      }
    },
    /**
     * 模型分组-点击修改
     */
    editGroupBut(item) {
      this.dialog_form_input.id = item.id
      this.dialog_form_input.name = item.name
      this.dialog_form_input.type = 1
    },
    /**
     *  模型分组-关闭弹窗
     */
    closeGroupBut() {
      this.dialog_form_input.id = ''
      this.dialog_form_input.name = ''
      this.dialog_form_input.type = 2
    },
    /**
     * 模型分组- 点击添加
     */
    addGroupBut() {
      this.dialog_form_input.id = ''
      this.dialog_form_input.name = ''
      this.dialog_form_input.type = 0
    },
    /**
     * 点击编辑模型分组
     */
    opendialog () {
      this.searchModelGroupList(false)
      this.dialog.show = true
    },
    /**
     * 点击修改
     */
    edit(item) {
      // eslint-disable-next-line eqeqeq
      if (item.type === 0) {
        const json = {
          isOpen: false,
          pageNumber: this.pageBuild.currentPage,
          groupId: this.form_select.group,
          status: this.form_select.status,
          name: this.form_select.name,
          qcType: this.form_select.modelType,
          skillId: this.form_select.skillId,
          type: this.form_select.type,
          attrPos: this.form_select.attrPos
        }
        window.sessionStorage.setItem('qcModelMgrQueryData', JSON.stringify(json))
        this.$router.push({
          path: '/qc/newModel/newModel_semanticsModule',
          query: {
            id: item.id,
            modelType: item.model_type
          }
        })
      }
      // eslint-disable-next-line eqeqeq
      if (item.type === 1) {
        const json1 = {
          isOpen: false,
          pageNumber: this.pageBuild.currentPage,
          groupId: this.form_select.group,
          // eslint-disable-next-line eqeqeq
          status: (this.form_select.status + '') == '' ? [] : [this.form_select.status.toString()],
          name: this.form_select.name,
          qcType: this.form_select.modelType,
          skillId: this.form_select.skillId,
          type: this.form_select.type,
          attrPos: this.form_select.attrPos
        }
        window.sessionStorage.setItem('qcModelMgrQueryData', JSON.stringify(json1))
        this.$router.push({
          path: '/qc/newModel/newModel_behaviorModule',
          query: {
            id: item.id,
            modelType: item.model_type
          }
        })
      }
    },
    /**
     * 点击删除
     */
    reomve(id) {
      // eslint-disable-next-line eqeqeq
      if (id == this.remove_id) {
      } else {
        this.remove_id = id
        window.qcMessageBox({ title: '', text: '你确定要删除该模型吗？', f: this.deleteModel, c: this.removeC })
      }
    },
    /**
     * 取消删除模型
     */
    removeC() {
      this.remove_id = ''
    },
    /**
     * 点击上线还是下线
     */
    status(item) {
      // eslint-disable-next-line eqeqeq
      if (item.id == this.status_id) {
      } else {
        this.status_id = item.id
        const params = {
          id: item.id,
          // eslint-disable-next-line eqeqeq
          type: (item.status == 1) ? 1 : 0
        }
        updateModelFlagPublish(params).then(response => {
          response = response.data.data
          // eslint-disable-next-line eqeqeq
          if (response.status == 'success') {
          } else {
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].id === item.id) {
                this.tableData[i].status = 0
              }
            }
            window.qcMessage({ type: 'warning', text: '修改状态失败' })
          }
          this.status_id = ''
        }).catch(response => {
          this.status_id = ''
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].id === item.id) {
              this.tableData[i].status = 0
            }
          }
          window.qcMessage({ type: 'warning', text: '修改状态失败' })
        })
      }
    },
    /**
     * 表格序号
     */
    indexMethod(index) {
      return index + 1 + this.pageBuild.page_size * (this.pageBuild.currentPage - 1)
    },
    /**
     * 点击分页回调
     */
    currentPage(currentPage) {
      this.pageBuild.currentPage = currentPage
      this.search()
    },
    /**
     * 表格绑定条件改变时
     */
    filterChange: function (value) {
      let f = false
      let isFilter = false
      if (value.status) {
        if (value.status.length > 0) {
          this.form_select.status = value.status
        } else {
          this.form_select.status = []
        }
        f = true
        isFilter = true
      }
      if (value.type) {
        if (value.type.length > 0) {
          this.form_select.modelType = value.type[0]
        } else {
          this.form_select.modelType = ''
        }
        f = true
        isFilter = true
      }
      if (value.typeTemplate) {
        if (value.typeTemplate.length > 0) {
          this.form_select.type = value.typeTemplate[0]
        } else {
          this.form_select.type = ''
        }
        f = true
        isFilter = true
      }
      if (value.attrPoss) {
        if (value.attrPoss.length > 0) {
          this.form_select.attrPos = value.attrPoss[0]
        } else {
          this.form_select.attrPos = ''
        }
        f = true
        isFilter = true
      }
      if (f) {
        this.clickSearch()
      }
      if (isFilter === false) {
        this.tableShow.createdUser = false
        this.tableShow.updateUser = false
        this.tableShow.createdTime = false
        this.tableShow.roles = false
        this.tableShow.updateTime = false
      }
      if (value.columns && value.columns.length > 0) {
        for (var k = 0; k < value.columns.length; k++) {
          // eslint-disable-next-line eqeqeq
          if (value.columns[k] == 1) {
            this.tableShow.createdUser = true
          }
          // eslint-disable-next-line eqeqeq
          if (value.columns[k] == 2) {
            this.tableShow.updateUser = true
          }
          // eslint-disable-next-line eqeqeq
          if (value.columns[k] == 4) {
            this.tableShow.createdTime = true
          }
          // eslint-disable-next-line eqeqeq
          if (value.columns[k] == 3) {
            this.tableShow.roles = true
          }
          // eslint-disable-next-line eqeqeq
          if (value.columns[k] == 5) {
            this.tableShow.updateTime = true
          }
        }
      }
    },
    clickSearch() {
      this.pageBuild.currentPage = 1
      this.search()
    },
    /**
     * 查询分页信息
     */
    search() {
      // 获取参数
      const params = {
        number: this.pageBuild.currentPage,
        size: this.pageBuild.page_size,
        name: this.form_select.name,
        status: this.form_select.status.length > 0 ? this.form_select.status[0] : '',
        group: this.form_select.group,
        modelType: this.form_select.modelType,
        skillId: this.form_select.skillId,
        type: this.form_select.type,
        attrPos: this.form_select.attrPos
      }
      this.load_table = true
      modelManagerList(params).then(response => {
        response = response.data.data
        // eslint-disable-next-line eqeqeq
        if (response.status == 'success') {
          this.pageBuild.total = response.pageData.totalProperty
          const list = response.pageData.root
          const array = []
          for (var i = 0; i < list.length; i++) {
            const json = {
              id: list[i].id,
              model_type: list[i].qcType,
              type: list[i].type,
              group: list[i].groupId,
              name: list[i].name,
              role: list[i].attrRole,
              updateDate: list[i].updatedTime,
              createUser: list[i].createdBy,
              updateUser: list[i].updatedBy,
              status: list[i].flagPublish,
              item: list[i],
              remark: list[i].remark,
              createdTime: list[i].createdTime,
              skillGroup: list[i].skillGroupId,
              attrActionId: list[i].attrActionId,
              attrPos: list[i].attrPos,
              attrPosValue: list[i].attrPosValue
            }
            array.push(json)
          }
          this.tableData = array
        }
        this.load_table = false
      }).catch(response => {
        this.load_table = false
      })
    },
    /**
     * 查询模型分组
     * @type 是否更新页面模组信息 true=是 false=否
     */
    searchModelGroupList(type) {
      modelGroupList({ name: (type ? '' : this.modelGroupSelectName) }).then(response => {
        response = response.data
        // eslint-disable-next-line eqeqeq
        if (response.data.status == 'success') {
          const list = response.data.list
          this.modelGroupAll = list
          if (type) {
            const array = []
            for (var i = 0; i < list.length; i++) {
              array.push({ text: list[i].name, value: list[i].id })
            }
            this.modelGroup = array
          }
        } else {
          if (type) {
            this.modelGroup = []
          }
          this.modelGroupAll = []
        }
      }).catch(response => {
        if (type) {
          this.modelGroup = []
        }
        this.modelGroupAll = []
      })
    },
    /**
     *  回调参数
     */
    routerSelect () {
      if (window.sessionStorage && window.sessionStorage.getItem('qcModelMgrQueryData')) {
        const json = JSON.parse(window.sessionStorage.getItem('qcModelMgrQueryData'))
        // eslint-disable-next-line eqeqeq
        if (json.isOpen == true) {
          this.form_select.modelType = json.qcType
          this.$refs.el_table.columns[1].filteredValue = (json.qcType === '' ? [] : [json.qcType])
          this.form_select.name = json.name
          this.form_select.status = json.status
          this.$refs.el_table.columns[7].filteredValue = json.status
          this.form_select.group = json.groupId
          this.pageBuild.currentPage = json.pageNumber
          this.form_select.skillId = json.skillId
          this.form_select.type = json.type
          this.form_select.attrPos = json.attrPos
          window.sessionStorage.removeItem('qcModelMgrQueryData')
        } else {
          window.sessionStorage.removeItem('qcModelMgrQueryData')
        }
      }
      this.search()
    },
    download() {
      var that = this
      var data = that.$refs.tree.getCurrentNode()
      if (data == null) {
        window.qcMessage({ type: 'warning', text: '请选择分组！' })
        return false
      }
      window.location.href = QCBASE + '/mgr/wordClass/exportKeyWords?' + 'bh=' + data.bh + '&name=' + that.keyWord_name + '&words=' + that.keyWord_words
    }
  },
  /**
   * 页面加载获取页面信息
   */
  mounted() {
    this.searchModelGroupList(true)
    // 查询技能组
    this.querySkillGroup()
  }
}
</script>

<style scoped>
    .max_box{
        width: 100%;
    }
    .top_box{
        width: 100%;
        border-bottom: #e1e3e6 solid 1px;
        padding-top: 12px;
        padding-bottom: 9px;
        margin-bottom: 20px;
    }
    .top_span{
        color: #222;
        font-size: 20px;
        padding-bottom: 10px;
        border-bottom: #0080fe solid 1px;
        padding-right: 5px;
    }
    .form_box{
        width: 100%;
    }
    .form_label{
        font-size: 14px;
    }
    .form_input{
        width: 160px;
        margin-right: 10px;
        margin-bottom: 10px;
        margin-left: 0px
    }
    .table_box_el_table{
        width: 100%;
    }
    .table_span{
        font-size: 12px;
        color: #666;
    }
    .table_span_ok{
        margin-left: 5px;
        font-size: 12px;
        color: #333;
        cursor:help
    }
    .table_button_box{}
    .dialog_top{
        width: 100%;
        margin-bottom: 10px;
    }
    .dialog_top_but{
        margin-left: 5px;
    }
    .dialog_body_in{
        width: auto;
        border-top: #eee solid 1px;
        border-left: #eee solid 1px;
        border-right: #eee solid 1px;
        /*padding: 15px 10px 0 10px;*/
        border-radius: 4px 4px 0 0;
    }
    .right{
        float: right;
    }
    .dialog_form_input{
        width: 185px;
        margin-right: 20px;
        margin-left: 0px;
    }
    .dialog_body_top{
        height: 36px;
        line-height: 36px;
        font-size: 12px;
        background: #f7f8fa;
        padding: 0 10px;
        /*position: absolute;
        margin-top: -23px;
        margin-left: 10px;*/
        color: #333;
    }
    .dialog_body_top_close{
      float: right;
        display: inline-block;
        font-size: 16px;
        color: #aaa;
        cursor:pointer;
    }
    .dialog_body_top_close:hover{
        color: #F56C6C;
    }
    .dialog_content {
      padding: 20px;
    }
    .dialog_foot{
        width: auto;
        padding: 20px 10px 10px 20px;
        border-radius: 0px 0px 4px 4px;
        border: #eee solid 1px;
        max-height: 160px;
        overflow-y: auto;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
    }
    .dialog_foot::-webkit-scrollbar {
        width: 3px;
    }
    .dialog_foot::-webkit-scrollbar-track {
        background-color:#fff;
        -webkit-border-radius: 1px;
        -moz-border-radius: 1px;
        border-radius:1px;
    }
    .dialog_foot::-webkit-scrollbar-thumb {
        background-color:#ddd;
        -webkit-border-radius: 1px;
        -moz-border-radius: 1px;
        border-radius:1px;
        border-radius:10px;
    }
    .dialog_foot_div{
        width: 145px;
        border-radius: 4px;
        border: #eee solid 1px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0px 10px;
        float: left;
        margin: 0px 10px 10px 0;
        text-align: center;
        position: relative;
        height: 60px;
        line-height: 60px;
    }
    .dialog_foot_div:hover{
        color: #409EFF;
        border: #409EFF solid 1px;
    }
    .dialog_foot_div_activity{
        color: #409EFF !important;
        border: #409EFF solid 1px !important;
    }
    .dialog_foot_div_close{
        color: #f1f1f1;
        margin-top: 0px;
        margin-left: 120px;
        border-radius: 0 4px 0 0;
        cursor:pointer;
        width:1px;
        height:0px;
        border-left:25px solid #fff;
        border-top:25px solid #f1f1f1;
    }
    .dialog_foot_div_close:hover{
        color: #fff;
        border-top:25px solid #F56C6C;
    }
    .dialog_foot_div_close_text{
        position: absolute;
        font-size: 8px;
        font-weight: bolder;
        margin: -22px 0 0 -24px;
        display: inline-block;
    }
    .el-tooltip:focus{
        border: 0 !important;
        outline: #ffffff;
    }
    .el-table >>> thead tr th{
        background: #f1f1f1 !important;
        padding: 6px 0 !important;
        color: #444 !important;
    }
    .el-table >>> tbody tr td {
        padding: 10px 5px;
    }
  .selectInput {
    box-sizing: border-box;
    margin-bottom: 10px;
    margin-right: 10px;
  }
  .dialog_top .selectInput >>> .el-input__suffix {
    height: 34px;
  }
    .dialog_top .selectInput >>> .el-input__suffix .el-input__suffix-inner .icon {
    margin-top: 9px;
  }
</style>
<style>
    .form_input.el-input-group > .el-input__inner {
        vertical-align: middle;
        display: inline-block;
    }
</style>
